module.exports = __webpack_public_path__ + "img/heating-control-lg.a735e41f.svg";